export enum StoreModule {
    GOODS = 'GOODS',
    LEAGUE = 'LEAGUE',
    YELLOWCAR = 'YELLOWCAR',
    DISTRIBUTION = 'DISTRIBUTION',
    PROMOTION = 'PROMOTION',
    SHOP = 'SHOP',
    PAY_BINDING = 'PAY_BINDING',
    NOTIFICATION = 'NOTIFICATION',
}
